import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import icedImg from "../assets/img/iced.png";
import evtarangImg from "../assets/img/evtarang.png";
import agripvImg from "../assets/img/agripv.png";
import tnClimateImg from "../assets/img/tn_climate.png";
import gujaratClimateImg from "../assets/img/gujarat_climate.png";
import keralaClimateImg from "../assets/img/kerala_climate.png";
import ghgPlatformImg from "../assets/img/ghg_platform.png";
import energyTransitionImg from "../assets/img/energy_transition.png";
import solarCitiesImg from "../assets/img/solar_cities.png";
import vasudhaImg from "../assets/img/vasudha.png";
import mediumorchidImg from "../assets/img/mediumorchid.png";
import dataexplorerImg from "../assets/img/dataexplorer.png";
import pmsImg from "../assets/img/pms.png";
import nyasaImg from "../assets/img/nyasa.png";
import chakraviewImg from "../assets/img/chakraview.png";
import centauriResImg from "../assets/img/centauri_res.png";
import centauriTechImg from "../assets/img/centauri_tech.png";
import tantohImg from "../assets/img/tantoh.png";
import kngexImg from "../assets/img/kngex.png";
import school1Img from "../assets/img/school1.png";
import abakwaehImg from "../assets/img/abakwaeh.png";
import paperplayImg from "../assets/img/paperplay.png";
import thesisImg from "../assets/img/thesis.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const govtProjects = [
    {
      title: "ICED Platform (NITI Aayog)",
      description: "National Climate & Energy Analytics",
      imgUrl: icedImg,
      url: "https://iced.niti.gov.in/",
    },
    {
      title: "EV Tarang Portal",
      description: "EV Subsidy Management (MP Govt)",
      imgUrl: evtarangImg,
      url: "https://evtarang.mp.gov.in/",
    },
    {
      title: "TN Climate Tracker",
      description: "Climate Action Monitoring for Tamil Nadu",
      imgUrl: tnClimateImg,
      url: "https://tnclimatetracker.tn.gov.in/",
    },
    {
      title: "Gujarat Climate Tracker",
      description: "Climate Data Visualization for Gujarat",
      imgUrl: gujaratClimateImg,
      url: "https://climatetracker.gujarat.gov.in/",
    },
    {
      title: "Kerala Climate Portal",
      description: "State-wide Climate Change Tracking",
      imgUrl: keralaClimateImg,
      url: "https://climatechange.envt.kerala.gov.in/",
    },
    {
      title: "GHG Platform India",
      description: "Greenhouse Gas Emission Analytics",
      imgUrl: ghgPlatformImg,
      url: "https://www.ghgplatform-india.org/",
    },
    {
      title: "Energy Transition Platform",
      description: "Clean Energy Transition Monitoring",
      imgUrl: energyTransitionImg,
      url: "https://energytransitionplatform.org/",
    },
    {
      title: "Solar Cities Portal",
      description: "Solar Energy Deployment (UPNEDA)",
      imgUrl: solarCitiesImg,
      url: "https://solarcitiesportal.upneda.org.in/",
    },
    {
      title: "Agri-PV Dashboard",
      description: "GIS-based Agri-Photovoltaic Analysis",
      imgUrl: agripvImg,
      url: "https://gis.vasudha-foundation.org/live/upagripv/index.html",
    },
    {
      title: "Vasudha Foundation",
      description: "Institutional Organization Website",
      imgUrl: vasudhaImg,
      url: "https://vasudha-foundation.org/",
    },
    {
      title: "Energy Portal",
      description: "Dynamic Energy Insights & Tracking",
      imgUrl: mediumorchidImg,
      url: "http://mediumorchid-bat-895218.hostingersite.com/",
    },
  ];

  const personalProjects = [
    {
      title: "Data Explorer",
      description: "Interactive Data Visualization Hub",
      imgUrl: dataexplorerImg,
      url: "https://ajayprajapati.com/dataexplorer",
    },
    {
      title: "Project Management System",
      description: "Task & Milestone Tracking Solution",
      imgUrl: pmsImg,
      url: "https://ajayprajapati.com/pms",
    }
  ];

  const clientProjects = [
    {
      title: "Nyasa Capital",
      description: "Finance & Investment Solutions",
      imgUrl: nyasaImg,
      url: "https://nyasacapital.in/",
    },
    {
      title: "Chakraview",
      description: "Security & Surveillance Tech",
      imgUrl: chakraviewImg,
      url: "https://www.chakraview.co.in/",
    },
    {
      title: "Centauri Research",
      description: "Strategic Research Services",
      imgUrl: centauriResImg,
      url: "https://www.centauri-research.com/",
    },
    {
      title: "Centauri Tech",
      description: "Technical Infrastructure Solutions",
      imgUrl: centauriTechImg,
      url: "https://www.centauri-technologies.com/",
    },
    {
      title: "TantoH",
      description: "Global Product Platform",
      imgUrl: tantohImg,
      url: "https://www.tantoh.com/",
    },
    {
      title: "KNGEX",
      description: "Logistics & Supply Chain Hub",
      imgUrl: kngexImg,
      url: "https://kngex.com/",
    },
    {
      title: "Abakwaeh",
      description: "Global Development Initiative",
      imgUrl: abakwaehImg,
      url: "https://abakwaeh.org/",
    },
    {
      title: "PaperPlay",
      description: "Creative Design & Print Solutions",
      imgUrl: paperplayImg,
      url: "https://paperplay.co.in/",
    },
    {
      title: "Thesis Hub",
      description: "Academic Research Support",
      imgUrl: thesisImg,
      url: "https://thesiswritinghub.com/",
    },
    {
      title: "School Portal",
      description: "Educational Management Interface",
      imgUrl: school1Img,
      url: "https://schools.ajayprajapati.com/school1/index.html",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Projects</h2>
                  <p>A collection of national-level platforms, data automation tools, and professional client websites I have developed and scaled.</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item style={{cursor:'pointer'}}>
                        <Nav.Link eventKey="first">Govt & Impact</Nav.Link>
                      </Nav.Item>
                      <Nav.Item style={{cursor:'pointer'}}>
                        <Nav.Link eventKey="second">Tools & Independent</Nav.Link>
                      </Nav.Item>
                      <Nav.Item style={{cursor:'pointer'}}>
                        <Nav.Link eventKey="third">Other Projects (During Internship)</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                      <Tab.Pane eventKey="first">
                        <Row>
                          {
                            govtProjects.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Row>
                          {
                            personalProjects.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <Row>
                          {
                            clientProjects.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
